import api from '~/api';
import {
  BankAccountSameDayMicrodepositResponse,
  BankAccountVerificationResponse,
  ValidateBankAccountTokenPayload,
} from '../dtos/bankAccountResponse';

export const getBankAccountVerification = async (partnerId: string): Promise<string> => {
  const { data } = await api.get<BankAccountVerificationResponse>(
    `/v1/partner/${partnerId}/payment_method/verification`
  );

  return data.link_token || '';
};

export const validateBankAccount = async (partnerId: string, token: string): Promise<void> => {
  const payload: ValidateBankAccountTokenPayload = {
    public_token: token,
  };

  return await api.post(`/v1/partner/${partnerId}/payment_methods`, payload);
};

export const getSameDayMicrodepositLink = async (partnerId: string): Promise<string> => {
  const { data } = await api.get<BankAccountSameDayMicrodepositResponse>(
    `/v1/partner/${partnerId}/payment_method/verification/same_day_microdeposit`
  );

  return (data && data?.link_token) ?? '';
};

export const startSameDayMicrodepositValidation = async (
  partnerId: string,
  token: string
): Promise<void> => {
  await api.post(`/v1/partner/${partnerId}/payment_method/verification/same_day_microdeposit`, {
    public_token: token,
  });
};

export const deleteBankAccountValidation = async (partnerId: string): Promise<void> => {
  await api.delete(`/v1/partner/${partnerId}/payment_method/verification/same_day_microdeposit`);
};
